import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              {t('home.categoriesTitle')}
            </h2>
            <p className="mt-1 text-sm text-foreground-500">探索你感兴趣的视频内容</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            {t('home.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer group"
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}